import styled, { css } from 'styled-components';
import { getSpace } from '../../../foundation/theme/space.utils';
import tokens from '../../../foundation/tokens/js/tokens';
import { FLAG_PADDING_SIZES, FLAG_VARIANT_BACKGROUND_COLOR, FLAG_VARIANT_COLOR } from './Flag.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const FlagRoot = styled.div `
  ${({ size, variant }) => {
    const verticalPadding = getSpace(FLAG_PADDING_SIZES[size].vertical);
    const horizontalPadding = getSpace(FLAG_PADDING_SIZES[size].horizontal);
    return css `
      /* Fixed rules */
      align-items: center;
      clip-path: polygon(
        0px 0px,
        100% 0px,
        calc(100% - 0.5rem) 50%,
        100% 100%,
        0px 100%
      );
      display: inline-flex;
      gap: ${getSpace('s')};

      /* Color */
      background-color: ${FLAG_VARIANT_BACKGROUND_COLOR[variant]};
      border-left: 4px solid ${tokens.colors.midnight[800].value};
      color: ${FLAG_VARIANT_COLOR[variant]};

      /* Paddings */
      padding-bottom: ${verticalPadding};
      padding-left: ${horizontalPadding};
      padding-top: ${verticalPadding};
      padding-right: ${horizontalPadding};

      .flag__text {
        text-transform: uppercase;
        padding-right: ${horizontalPadding};
      }
    `;
}}
`;
//# sourceMappingURL=Flag.styled.js.map